import React from 'react'
import { string, shape } from 'prop-types'

const ArticleBody = props => (
  <div className='panel-body article-body'>
    <a href={props.link}>
      { props.children }
    </a>
  </div>
)

const Article = props => {
  const link = `${props.urlBase}${props.article.link}`
  // Title and description have a full stop appended to the end, remove them.
  const title = props.article.title.slice(0, -1)
  const description = props.article.description.slice(0, -1)
  const image = encodeURI(props.article.image)
  return (
    <div className='col-xs-12 col-sm-6 col-md-3 article'>
      <div className='panel panel-primary'>
        <ArticleBody link={link}>
          <div className='article-img article-img-rounded' data-original-background={`url(${image})`} />
          <h3>{title}</h3>
          <p>{description}</p>
        </ArticleBody>
      </div>
    </div>
  )
}

Article.propTypes = {
  urlBase: string.isRequired,
  article: shape({
    title: string.isRequired,
    description: string.isRequired,
    link: string.isRequired,
    image: string.isRequired
  })
}

ArticleBody.propTypes = {
  link: string.isRequired
}

export default Article
